import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';

import { useEmbGridColumnDefs } from '../utils/columnDefs';

type Props = {
  mode?: string;
  rowData: any[] | null;
};

export const EmbGrid = ({ mode, rowData }: Props) => {
  const defaultGridOptions = useDefaultGridOptions();
  const embGridColumnDefs = useEmbGridColumnDefs();

  return (
    <div className="aspiration__emb-grid overflow-auto">
      <WithLocalStorage storageKey="aspiration__emb-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${mode === 'dark' ? '-dark' : ''}`}
          rowData={rowData || null}
          defaultColDef={defaultColDef}
          columnDefs={embGridColumnDefs}
          rowSelection="single"
          getRowId={(params) => params.data.id}
        />
      </WithLocalStorage>
    </div>
  );
};
